import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Medication"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 1.5H6C5.17157 1.5 4.5 2.17157 4.5 3V6C4.5 6.82843 5.17157 7.5 6 7.5V21C6 21.8284 6.67157 22.5 7.5 22.5H16.5C17.3284 22.5 18 21.8284 18 21V7.5C18.8284 7.5 19.5 6.82843 19.5 6V3C19.5 2.17157 18.8284 1.5 18 1.5ZM7.5 10.5H9.75V18H7.5V10.5ZM16.5 21H7.5V19.5H11.25V9H7.5V7.5H16.5V21ZM6 6V3H18V6H6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Medication.vue"]]);
